import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Spinner} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {Announcement} from './announcement';
import FeedItemsState from '../state/FeedItemsState';
import useInfiniteScroll from 'react-infinite-scroll-hook';

const FeedSection = observer(({message, items, feedState}) => {
  if (items.length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <div className='FeedSectionTitle medium h3 mb1'>
        <FormattedMessage id={message}/>
      </div>
      <div className='TimelineSeparator'/>
      <div>
        {items.map((announcement, index) =>
          <Announcement
            key={index}
            announcement={announcement}
            emojiReady={feedState.emojiReady}
            openEditAnnouncementModal={() => feedState.openEditAnnouncementModal(announcement)}
            openDeleteAnnouncementModal={() => feedState.openDeleteAnnouncementModal(announcement)}
            pinAnnouncement={() => feedState.pinAnnouncement(announcement)}
            unpinAnnouncement={() => feedState.unpinAnnouncement(announcement)}
          />)
        }
      </div>
    </React.Fragment>
  );
});

const EmptyState = observer(({uiState}) => {
  const {feedItems} = uiState;
  if (feedItems.length > 0) {
    return null;
  }

  return (
    <div className='center jumbo rounded h5 py2 px1 Table-emptyState'>
      <FormattedMessage id='hr_dashboard.feed.No items to display'/>
    </div>
  );
});

const FeedItems = observer(({uiState}) => {
  const {
    pinnedFeedItems,
    currentFeedItems,
    olderFeedItems,
    nextLink,
    feedState
  } = uiState;

  const {loading} = feedState;

  const [infiniteRef] = useInfiniteScroll({
    loading,
    hasNextPage: !!nextLink,
    onLoadMore: () => feedState.loadMore(),
    rootMargin: '0px 0px 500px 0px',
  });

  return (
    <div>
      <EmptyState uiState={uiState}/>
      <FeedSection message='hr_dashboard.feed.Pinned' items={pinnedFeedItems} feedState={feedState}/>
      <FeedSection message='hr_dashboard.feed.Current' items={currentFeedItems} feedState={feedState}/>
      <FeedSection message='hr_dashboard.feed.Older' items={olderFeedItems} feedState={feedState}/>
      {!!nextLink && <div ref={infiniteRef}>
        <Spinner/>
      </div>}
    </div>
  );
});

export default withState(FeedItems, FeedItemsState);
